export default __webpack_public_path__ + "static/media/face10.c27c6b5d.svg";